// extracted by mini-css-extract-plugin
export default {"buttonContainer":"tableOrders_buttonContainer__uJFOS","firstButton":"tableOrders_firstButton__lfcYp"};